import { FunctionComponent } from 'react'
import useStyles from './styles'
import { Interpolation, Theme } from '@emotion/react'
import { Loader as BaseLoader } from '@conexasaude/conexa-hero'

interface LoaderProps {
  css?: Interpolation<Theme>
}

const Loader: FunctionComponent<LoaderProps> = props => {
  const styles = useStyles()

  return (
    <div css={styles.root} {...props}>
      <BaseLoader size="medium" />
    </div>
  )
}

export default Loader
